import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createMetaManager } from "vue-meta";

import gtag, { googleTagManager } from "./utils/gtag";
import hotjar from "./utils/hotjar";
import sentry from "./utils/sentry";
import naverMap from "./utils/naverMap";
import recaptcha from "./utils/recaptcha";

import SetupCalendar, { Calendar, DatePicker } from "v-calendar";
import { initMixpanel } from "./utils/mixpanel";

import directive from "./utils/directive";
import axiosInterceptor from "./utils/axiosInterceptor";
import initializeStore from "./utils/initializeStore";
import { printConsole } from "./utils/console";
import { setupI18n } from "@/utils/i18n"

const initSetup = async () => {
  const i18n = await setupI18n();
  const app = createApp(App);

  app
    .use(store)
    .use(router)
    .use(i18n)
    .use(directive)
    .use(axiosInterceptor)
    .use(initializeStore)
    .use(naverMap)
    .use(hotjar)
    .use(sentry, router)
    .use(gtag)
    .use(recaptcha)
    .use(googleTagManager)
    .use(printConsole)
    .use(initMixpanel)
    .use(SetupCalendar, {})
    .use(createMetaManager())
    .component("Calendar", Calendar)
    .component("DatePicker", DatePicker)
    .mount("#app");

}
initSetup();